const translations = {
  fr: {
    currencyPeriods: {
      currencyText: '{{name}} ({{from, LL}} au {{to, LL}})',
    },
  },

  en: {
    currencyPeriods: {
      currencyText: '{{name}} ({{from, LL}} to {{to, LL}})',
    },
  },
};

export default translations;



// WEBPACK FOOTER //
// ./src/statsradio/modules/currencyPeriod/i18n/currencyPeriods.js